import {
  getOrderCountStatusAllTime,
  getOrderCountStatusMonth,
  getOrderDetail,
  getOrders,
  setCancelOrder,
  setRefundOrder,
  getSellerOrderNotes,
  createSellerOrderNote,
  getSellerOrderNoteDetail,
  updateSellerOrderNote,
  deleteSellerOrderNote
} from "../network/orderApi";
import { useOrdersStore } from "../store/orderStore";

export const fetchOrders = async (params) => {
  const { setOrders } = useOrdersStore.getState();
  try {
    const response = await getOrders(params);
    setOrders(response);
    return response;
  } catch (error) {
    console.error("Failed to fetch services", error);
  }
};
export const fetchOrderDetail = async (id) => {
  const { setOrderDetail } = useOrdersStore.getState();
  try {
    const response = await getOrderDetail(id);
    setOrderDetail(response?.order);
    return response;
  } catch (error) {
    console.error("Failed to fetch services", error);
  }
};
export const fetchOrderCountStatusAllTime = async () => {
  const { setOrderCountStatusAllTime } = useOrdersStore.getState();
  try {
    const response = await getOrderCountStatusAllTime();
    setOrderCountStatusAllTime(response?.countStatus);
    return response?.countStatus;
  } catch (error) {
    console.error("Failed to fetch services", error);
  }
};
export const fetchOrderCountStatusMonth = async (params) => {
  const { setOrderCountStatusMonth } = useOrdersStore.getState();
  try {
    const response = await getOrderCountStatusMonth(params);
    setOrderCountStatusMonth(response?.countStatus);
    return response?.countStatus;
  } catch (error) {
    console.error("Failed to fetch services", error);
  }
};
export const fetchCancelOrder = async ({ orderId, reason }) => {
  const { setCancelOrderProduct } = useOrdersStore.getState();
  try {
    const response = await setCancelOrder({ orderId, reason });
    setCancelOrderProduct({
      isCancelOrder: response?.data?.message === 'success',
    });
    return response;
  } catch (error) {
    console.error("Failed to fetch services", error);
  }
};
export const fetchRefundOrder = async ({ orderId, reason }) => {
  const { setRefundOrderProduct } = useOrdersStore.getState();
  try {
    const response = await setRefundOrder({ orderId, reason });
    setRefundOrderProduct({
      isRefundOrder: response?.data?.message === 'success',
    });
    return response;
  } catch (error) {
    console.error("Failed to fetch services", error);
  }
};

export const fetchOrderNotes = async (id, params) => {
  const { setOrderNotes } = useOrdersStore.getState();
  try {
    const response = await getSellerOrderNotes(id, params);
    setOrderNotes(response);
    return response;
  } catch (error) {
    console.error("Failed to fetch order notes", error);
  }
};

export const fetchCreateOrderNote = async (id, payload) => {
  try {
    const response = await createSellerOrderNote(id, payload);
    return response;
  } catch (error) {
    console.error("Failed to create order note", error);
  }
};

export const fetchOrderNoteDetail = async (id, noteId) => {
  try {
    const response = await getSellerOrderNoteDetail(id, noteId);
    return response;
  } catch (error) {
    console.error("Failed to fetch order note detail", error);
  }
};

export const fetchUpdateOrderNote = async (id, noteId, payload) => {
  try {
    const response = await updateSellerOrderNote(id, noteId, payload);
    return response;
  } catch (error) {
    console.error("Failed to update order note", error);
  }
};

export const fetchDeleteOrderNote = async (id, noteId) => {
  try {
    const response = await deleteSellerOrderNote(id, noteId);
    return response;
  } catch (error) {
    console.error("Failed to delete order note", error);
  }
};